var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.488,
    height: 19.333,
    viewBox: "0 0 27.488 19.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "road",
    transform: "translate(-0.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M16.49,11.177v-.06l-.362-4.833a.51.51,0,0,0-.166-.34.49.49,0,0,0-.347-.143H12.805a.49.49,0,0,0-.347.143.51.51,0,0,0-.166.34l-.362,4.833v.06a.346.346,0,0,0,.121.3.462.462,0,0,0,.317.121h3.685a.462.462,0,0,0,.317-.121A.346.346,0,0,0,16.49,11.177ZM27.954,18.23q0,1.1-.695,1.1H16.626a.44.44,0,0,0,.332-.143.426.426,0,0,0,.121-.34l-.3-3.867a.51.51,0,0,0-.166-.34.49.49,0,0,0-.347-.143H12.156a.49.49,0,0,0-.347.143.51.51,0,0,0-.166.34l-.3,3.867a.426.426,0,0,0,.121.34.44.44,0,0,0,.332.143H1.16q-.695,0-.695-1.1a4.548,4.548,0,0,1,.393-1.752L7.156.71a1.237,1.237,0,0,1,.393-.5A.921.921,0,0,1,8.123,0h5.12A.49.49,0,0,0,12.9.143a.51.51,0,0,0-.166.34l-.227,2.9a.425.425,0,0,0,.121.347.452.452,0,0,0,.332.136h2.507a.452.452,0,0,0,.332-.136.425.425,0,0,0,.121-.347L15.69.483a.51.51,0,0,0-.166-.34A.49.49,0,0,0,15.176,0H20.3a.921.921,0,0,1,.574.211,1.237,1.237,0,0,1,.393.5l6.3,15.768A4.548,4.548,0,0,1,27.954,18.23Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.c128d6e1c67707858782aab77653c285.svg";
export { ForwardRef as ReactComponent };